export default __webpack_public_path__ + "static/pic02-46a68ff9a89ee0293bb90e676d94155d.jpg";